module.exports = {"pageTitle":"공지사항","typePlaceholder":"유형","searchPlaceholder":"검색어를 입력하세요.","checking":"확인중","event":"이벤트","version":"버전","registerButton":"등록하기","target":"대상","type":"유형","subject":"제목","writer":"작성자","date":"작성일","notEntered":"미입력","golfClubCount":"골프클럽({n})","noPosts":"등록된 게시물이 없습니다.","prev":"이전","next":"다음","more":"더보기","replyAlert1":"답변을 등록하면 문의자에게","replyAlert2":"알림이 발송됩니다.","replyAlert3":"이대로 등록하시겠습니까?"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/cs001.json
// module id = 4+Ra
// module chunks = 2